import styled from "styled-components";
import NavBar from "../../../Componentes/NavBar";
import BodyWrapper from "./BodyWrapper";

const Container = styled.div`
    width: 100%;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    background-color: #242d34;
`

const BoletimMedicao = () => {
    return(
        <>
            <Container>
                <NavBar navTo="/modulo/controle-medicao/pedidos-compra" />
                <BodyWrapper />
            </Container>
        </>
    )
}

export default BoletimMedicao;